<template>
	<div class="origin-column" v-loading.fullscreen.lock="fullscreenLoading">
		<ul class="mini-avatar">
			<li
				class="avatar"
				v-for="(item, index) in imgList"
				:class="{ 'avatar-active': index === currentImgIndex }"
				:key="index"
				@click="choseCurrentImg(index)"
			>
				<img :src="item.imageAddr" alt="" class="avatar-img" ref="board" />
			</li>
		</ul>
		<div class="content-img">
			<div class="img-wrap">
				<div class="left-arrow"><i class="iconfont iconjiantouzuo" @click="prevImg" /></div>
				<div class="current-img">
					<img :src="currentSelectedImg" :style="compRotatePaper" class="current-img-content" alt="" ref="board" />
				</div>
				<div class="right-arrow"><i class="iconfont iconjiantouyou" @click="nextImg"></i></div>
			</div>
			<div class="operate-img">
				<div class="ope-img"><i class="iconfont iconfangda" @click="scalePage"></i></div>
				<div class="ope-img"><i class="iconfont iconfangda1" @click="miniPage"></i></div>
				<div class="ope-img"><i class="iconfont iconrotate-anticlockwise" @click="rotatePage"></i></div>
			</div>
		</div>
		<i class="iconfont iconcha" @click="closeOriginColumn"></i>
	</div>
</template>
<script>
import drag from '../mixin/drag-mixin'
export default {
	name: 'origin-column',
	mixins: [drag],
	data() {
		return {
			imgList: [],
			currentSelectedImg: '',
			currentImgIndex: 0,
			isContentPage: true,
			dragStartX: 0,
			dragStartY: 0,
			scaleState: 1,
			rotateDegree: 0,
			fullscreenLoading: false,
			query: this.$route.query
		}
	},
	computed: {
		compRotatePaper() {
			return { transform: `scale(${this.scaleState}) rotate(${this.rotateDegree}deg)` }
		}
	},
	mounted() {
		this.getImgList()
	},
	props: {
		basicInfo: {
			type: Object,
			default: () => {}
		}
	},
	methods: {
		// 关闭按钮
		closeOriginColumn() {
			this.eventBus.$emit('originColumnBoardState', false)
		},
		// 图片列表
		getImgList() {
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				studentId: this.basicInfo.studentId
			}
			this.$post('/examImgInfo/getOssStudentImage', params).then(res => {
				this.imgList = res.data.imgInfos
				this.currentSelectedImg = this.imgList[0].imageAddr
			})
		},
		// 下一张图片
		nextImg() {
			this.currentImgIndex += 1
			if (this.currentImgIndex === this.imgList.length) {
				this.currentImgIndex = 0
			}
			this.currentSelectedImg = this.imgList[this.currentImgIndex].imageAddr
		},
		// 上一张图片
		prevImg() {
			this.currentImgIndex -= 1
			if (this.currentImgIndex < 0) {
				this.currentImgIndex = this.imgList.length - 1
			}
			this.currentSelectedImg = this.imgList[this.currentImgIndex].imageAddr
		},
		// 索引 选择当前
		choseCurrentImg(index) {
			this.currentImgIndex = index
			this.currentSelectedImg = this.imgList[index].imageAddr
		},
		//放大图片
		scalePage() {
			this.scaleState += 0.1
			if (this.scaleState >= 3) {
				this.scaleState = 3
			}
		},
		// 缩小图片
		miniPage() {
			this.scaleState -= 0.1
			if (this.scaleState <= 0.1) {
				this.scaleState = 0.1
			}
		},
		// 旋转图片
		rotatePage() {
			this.fullscreenLoading = true
			const params = {
				imageId: this.imgList[this.currentImgIndex].pkId,
				examId: this.query.examId,
				userId: this.query.userId
			}
			this.$post('examImgInfo/teacherChoiceImage', params).then(res => {
				this.fullscreenLoading = false
				if (res.code === '200') {
					this.$set(this.imgList[this.currentImgIndex], 'imageAddr', res.data.imageAddr)
					this.currentSelectedImg = res.data.imageAddr
				} else {
					this.$message.error('旋转失败')
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.origin-column {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 30;
	background: rgba(0, 0, 0, 0.8);
	.mini-avatar {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 10px 0;
		.avatar {
			width: 120px;
			height: 80px;
			border-radius: 8px;
			margin-right: 20px;
			overflow: hidden;
			display: flex;
			justify-content: center;
			align-items: center;
			&:hover {
				cursor: pointer;
			}
		}
		.avatar-active {
			border: 2px solid red;
			box-sizing: border-box;
		}
		.avatar-img {
			max-width: 100%;
			max-height: 100%;
			object-fit: cover;
		}
	}
	.content-img {
		width: 100%;
		height: calc(100% - 110px);
		display: flex;
		justify-content: center;
		align-items: center;
		.img-wrap {
			width: 80%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;
			overflow: hidden;
			&:hover .left-arrow {
				display: block;
			}
			&:hover .right-arrow {
				display: block;
			}
			.current-img {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				overflow: hidden;
				.current-img-content {
					max-width: 100%;
					max-height: 100%;
				}
			}
			// .canvas-img {
			// }
		}
		.operate-img {
			position: absolute;
			right: 30px;
			top: 50%;
			transform: translateY(-50%);
			.ope-img {
				width: 90px;
				height: 90px;
				text-align: center;
				line-height: 90px;
				margin-top: 30px;
				border-radius: 50%;
				&:hover {
					cursor: pointer;
				}
				.iconfont {
					color: white;
					font-size: 55px;
				}
			}
		}
		.left-arrow {
			width: 60px;
			height: 60px;
			border-radius: 50%;
			position: absolute;
			top: 50%;
			left: 0;
			transform: translateY(-30px);
			text-align: center;
			line-height: 60px;
			display: none;
			&:hover {
				cursor: pointer;
			}
			i {
				color: white;
				font-size: 40px;
			}
		}
		.right-arrow {
			width: 60px;
			height: 60px;
			border-radius: 50%;
			position: absolute;
			top: 50%;
			right: 0;
			transform: translateY(-30px);
			text-align: center;
			line-height: 60px;
			display: none;
			&:hover {
				cursor: pointer;
			}
			i {
				color: white;
				font-size: 32px;
			}
		}
	}
	.iconcha {
		position: absolute;
		top: 20px;
		right: 20px;
		font-size: 32px;
		color: white;
		&:hover {
			cursor: pointer;
		}
	}
}
</style>
